import { get } from '../axios'

/* 查询所有活动类型
 * basePath:/activity/ext/activityTypes
 */

// import {ams_admin_activity_create_post} from '@server/modules/2682'

// const params = {}
// async ()=> {
//   const { success, data, retInfo } = await ams_admin_activity_ext_activityTypes_get({...params})
//   if (success) {
//     console.log(data)
//     Modal.success(retInfo)
//   } else {
//     console.log(data)
//     Modal.error(retInfo)
//   }
// }
export function ams_admin_activity_ext_activityTypes_get(map) {
  // 查询所有活动类型
  return get(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/activity/ext/activityTypes`,
    map
  )
}

/* 查询所有活动状态
 * basePath:/activity/ext/activityStatus
 */

// import {ams_admin_activity_create_post} from '@server/modules/2682'

// const params = {}
// async ()=> {
//   const { success, data, retInfo } = await ams_admin_activity_ext_activityStatus_get({...params})
//   if (success) {
//     console.log(data)
//     Modal.success(retInfo)
//   } else {
//     console.log(data)
//     Modal.error(retInfo)
//   }
// }
export function ams_admin_activity_ext_activityStatus_get(map) {
  // 查询所有活动状态
  return get(
    `${process.env.VUE_APP_AMS_ADMIN}/ams-admin/activity/ext/activityStatus`,
    map
  )
}

/* 站点主数据
 * basePath:/mdm/sites
 */

// import {ams_admin_activity_create_post} from '@server/modules/2682'

// const params = {}
// async ()=> {
//   const { success, data, retInfo } = await ams_admin_mdm_sites_get({...params})
//   if (success) {
//     console.log(data)
//     Modal.success(retInfo)
//   } else {
//     console.log(data)
//     Modal.error(retInfo)
//   }
// }
export function ams_admin_mdm_sites_get(map) {
  // 站点主数据
  return get(`${process.env.VUE_APP_AMS_ADMIN}/ams-admin/mdm/sites`, map)
}
